<!--
Author: TangChen
Date: 2019-02-28
Desc: 自选组合购买基金列表，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-optional-fund bizcomp ' + className">
        <comp-title :title="title" />
        <fund-risk-filter :qryall="qryallfund" v-on:qry-change="qryChange" />
        <combo-table ref="comboTable" v-on:combo-list="getData" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import comboTable from "@/components/fund/comboTable";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import { getRiskFilter } from "@/util";
export default {
    name: "OptionalFund",
    components: {
        comboTable,
        fundRiskFilter
    },
    mixins: [mixin],
    data() {
        return {
            selFund: [],
            url: "buyfund",
            qryallfund: getRiskFilter()
        };
    },
    mounted() {
        this.getSelFund();
    },
    methods: {
        getData(val) {
            let _this = this;
            val.proto = "buy";
            this.$util.fundRiskCheck(this, val, (res) => {
                if (res) {
                    const _x = Object.assign({}, res, { way: "20,22" });
                    sessionStorage.setItem(_this.url, JSON.stringify(_x));
                    _this.$router.push({ name: _this.url, query: { fundcode: res.fundcode } });
                }
            });
        },
        // 查询自选组合购买基金信息
        getSelFund(flag) {
            if (this.selFund.length > 0 && !flag) {
                this.$refs.comboTable.fundList = this.selFund;
                return;
            }
            let _this = this;
            const _x = {
                flag: "",
                pagecount: "1000",
                pageoffset: "0",
                qryallfund: this.qryallfund,
                qrysmflag: "1"
            };
            this.$util.request("trade/fund/list", _x).then((res) => {
                if (res.data) {
                    const _y = res.data[0].filter((item) => {
                        return _this.$util.checkComboBuy(item.fundstatus) === "";
                    });
                    _this.selFund = _y;
                    _this.qryallfund = res.data[1][0].qryallfund;
                    const info = _this.$cache.getUser();
                    info.qryallfund = _this.qryallfund;
                    _this.$store.dispatch("setInfo", info);
                    _this.$refs.comboTable.fundList = _y;
                }
            });
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.qryallfund = val;
            this.getSelFund(true);
        }
    }
};
</script>
<style lang="scss">
.bizcomp-optional-fund {
    .risk-filter-text {
        margin: 0;
        border: none;
        padding: 5px 10px;
    }
}
</style>
